import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

// Shared
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { SharedModule } from 'src/app/shared/modules/shared.module';

// Modules
import { UserModule } from 'src/app/workflow/user/user.module';

// App
import { AppComponent } from 'src/app/app.component';
import { AppRoutingModule } from 'src/app/app-routing.module';

// Pipes
import { DatePipe } from '@angular/common';
import { FromPicklistPipe } from 'src/app/shared/pipes/fromPicklistPipe.pipe';
import { ToPicklistPipe } from 'src/app/shared/pipes/toPicklistPipe.pipe';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

// General Components
import { GridTemplateComponent } from 'src/app/template/gridTemplate/gridTemplate.component';
import { FormularComponent } from 'src/app/template/formularTemplate/formularTemplate.component';
import { DayDatepickerFormatComponent } from 'src/app/datepicker-formats/day-datepicker-format/day-datepicker-format.component';
import { MonthDatepickerFormatComponent } from 'src/app/datepicker-formats/month-datepicker-format/month-datepicker-format.component';

// Navigation and Layout Components
import { HeaderComponent } from 'src/app/content/header/header.component';
import { SidebarComponent } from 'src/app/content/sidebar/sidebar.component';
import { FooterComponent } from 'src/app/content/footer/footer.component';
import { HomePageComponent } from 'src/app/pages/home-page/home-page.component';
import { WelcomePageComponent } from 'src/app/pages/welcome-page/welcome-page.component';

import { MapComponent } from 'src/app/map/map.component';
import { StatisticGridComponent } from 'src/app/statistic-grid/statistic-grid.component';

// Workflow Components


import { NewRequestComponent } from 'src/app/workflow/request/newRequest/new-request.component';
import { NewReqFormComponent } from 'src/app/workflow/request/newRequest/new-req-form/new-req-form.component';
import { personIdDialog } from 'src/app/workflow/request/newRequest/new-req-form/new-req-form.component';
import { CoordinateSearchPageComponent } from 'src/app/workflow/request/newRequest/coordinate-search-page/coordinate-search-page.component';
import { MapPageComponent } from 'src/app/workflow/request/newRequest/map-page/map-page.component';
import { ManualRequestComponent } from 'src/app/workflow/request/newRequest/manual-request/manual-request.component';
import { RequestOverviewComponent } from 'src/app/workflow/request/newRequest/request-overview/request-overview.component';
import { statisticModalWindow, StatisticsPageComponent } from 'src/app/workflow/statistic/statistics-page/statistics-page.component';
import { GipAdmDocEnvComponent } from 'src/app/workflow/admin/gipAdmContentList/gipAdmDocenv/gipAdmDocenv.component';
import { GipAdmDocPubComponent } from 'src/app/workflow/admin/gipAdmContentList/gipAdmDocpub/gipAdmDocpub.component';
import { GipAdmPropsComponent } from 'src/app/workflow/admin/gipAdmContentList/gipAdmProps/gipAdmProps.component';
//import { GipAdmTextComponent } from 'src/app/workflow/admin/gipAdmText/gipAdmText.component';
import { GipCompanyFormComponent } from 'src/app/workflow/admin/gipCompanyList/gipCompanyForm/gipCompanyForm.component';
import { GipCompanyListComponent } from 'src/app/workflow/admin/gipCompanyList/gipCompanyList.component';
import { GipUserLogonComponent } from 'src/app/workflow/user/gipUserLogonActivity/gipUserLogon/gipUserLogon.component';
import { GipLogonMaintComponent } from 'src/app/workflow/user/gipUserLogonActivity/gipLogonMaint/gipLogonMaint.component';
import { GipUserFormComponent } from 'src/app/workflow/user/gipUserEdit/gipUserForm/gipUserForm.component';
import { contractIdDialog } from 'src/app/workflow/user/gipUserEdit/gipUserForm/gipUserForm.component';
import { companyIdDialog } from 'src/app/workflow/user/gipUserEdit/gipUserForm/gipUserForm.component';
import { GipUserRegisterFormComponent } from 'src/app/workflow/user/gipUserReg/gipUserRegisterForm/gipUserRegisterForm.component';
import { GipUserProcessStatFormComponent } from 'src/app/workflow/user/gipUserReg/gipUserProcessStatForm/gipUserProcessStatForm.component';
import { GipUserResetPwdComponent } from 'src/app/workflow/user/gipUserLogonActivity/gipUserResetPwd/gipUserResetPwd.component';
import { GipUserForgotPwdComponent } from 'src/app/workflow/user/gipUserLogonActivity/gipUserForgotPwd/gipUserForgotPwd.component';
import { GipContractListComponent } from 'src/app/workflow/admin/gipAdmContract/gipContractList/gipContractList.component';
import { GipContractFormComponent } from 'src/app/workflow/admin/gipAdmContract/gipContractForm/gipContractForm.component';
import { GipContractFormatFormComponent } from 'src/app/workflow/admin/gipAdmContract/gipContractFormatForm/gipContractFormatForm.component';
import { GipContractScaleFormComponent } from 'src/app/workflow/admin/gipAdmContract/gipContractScaleForm/gipContractScaleForm.component';
import { GipContractPrinterFormComponent } from 'src/app/workflow/admin/gipAdmContract/gipContractPrinterForm/gipContractPrinterForm.component';
import { GipReqDnloadFormComponent } from 'src/app/workflow/download/gipReqDnloadForm/gipReqDnloadForm.component';
import { GipReqReplotFormComponent } from 'src/app/workflow/download/gipReqReplotForm/gipReqReplotForm.component';
import { GipReqResetFormComponent } from 'src/app/workflow/request/gipReqResetForm/gipReqResetForm.component';
import { GipUserListComponent } from 'src/app/workflow/user/gipUserReg/gipUserList/gipUserList.component';
import { GipContractFormatListComponent } from 'src/app/workflow/admin/gipAdmContract/gipContractFormatList/gipContractFormatList.component';
import { GipContractScaleListComponent } from 'src/app/workflow/admin/gipAdmContract/gipContractScaleList/gipContractScaleList.component';
import { GipContractPrinterListComponent } from 'src/app/workflow/admin/gipAdmContract/gipContractPrinterList/gipContractPrinterList.component';
import { GipAdmDocenvListComponent } from 'src/app/workflow/admin/gipAdmContentList/gipAdmDocenvList/gipAdmDocenvList.component';
import { GipAdmDocpubListComponent } from 'src/app/workflow/admin/gipAdmContentList/gipAdmDocpubList/gipAdmDocpubList.component';
import { GipAdmPropsListComponent } from 'src/app/workflow/admin/gipAdmContentList/gipAdmPropsList/gipAdmPropsList.component';
import { GipAdmTextListComponent } from 'src/app/workflow/admin/gipAdmContentList/gipAdmTextList/gipAdmTextList.component';
import { GipReqStatListComponent } from 'src/app/workflow/statistic/gipReqStat/gipReqStatList/gipReqStatList.component';
import { GipReqStatCListComponent } from 'src/app/workflow/statistic/gipReqStat/gipReqStatCList/gipReqStatCList.component';
import { GipReqStatCaListComponent } from 'src/app/workflow/statistic/gipReqStat/gipReqStatCaList/gipReqStatCaList.component';
import { GipReqStatSListComponent } from 'src/app/workflow/statistic/gipReqStat/gipReqStatSList/gipReqStatSList.component';
import { GipReqStatCsListComponent } from 'src/app/workflow/statistic/gipReqStat/gipReqStatCsList/gipReqStatCsList.component';
import { GipReqStatAListComponent } from 'src/app/workflow/statistic/gipReqStat/gipReqStatAList/gipReqStatAList.component';
import { GipReqManListComponent } from 'src/app/workflow/request/gipReqManList/gipReqManList.component';
import { GipReqLogComponent } from 'src/app/workflow/request/gipReqLog/gipReqLog.component';
import { GipAdmTextComponent } from './workflow/admin/gipAdmContentList/gipAdmText/gipAdmText.component';
import { GipReqManFormComponent } from './workflow/request/gipReqManForm/gipReqManForm.component';
import { GipReqManComponent } from './workflow/request/gipReqMan/gipReqMan.component';
import { GipReqManFwdFormComponent } from './workflow/request/gipReqManFwdForm/gipReqManFwdForm.component';
import { GipUserChangePwdFormComponent } from './workflow/user/gipUserLogonActivity/gipUserChangePwdForm/gipUserChangePwdForm.component'
import { personFwdDialog } from './workflow/request/gipReqManFwdForm/gipReqManFwdForm.component';
import { personMailDialog } from './workflow/request/gipReqManForm/gipReqManForm.component';
import { ToastrModule } from 'ngx-toastr';
import { GipAdmUserPwdResetComponent } from './workflow/user/gipUserEdit/gipAdmUserPwdReset/gipAdmUserPwdReset.component';
import { ConfirmationWindow } from './template/deleteTemplate/confirmationWindow.component';
import { NoteEditDialogComponent } from './workflow/request/gipReqManForm/noteEditDialog/noteEditDialog.component';
import { TranslateTextPipe } from './shared/pipes/translateText.pipe';
import { GipActivateAccountComponent } from './workflow/user/gipUserLogonActivity/gipActivateAccount/gipActivateAccount.component';
import { PointReplacerPipe } from './shared/pipes/pointReplacer.pipe';
import { UploadDialogComponent } from './template/uploadDialog/uploadDialog.component';


@NgModule({
  declarations: [
    AppComponent,
    ToPicklistPipe,
    FromPicklistPipe,
    TranslateResourceDefinitionPipe,
    TranslateTextPipe,
    PointReplacerPipe,

    FormularComponent,
    GridTemplateComponent,

    DayDatepickerFormatComponent,
    MonthDatepickerFormatComponent,

    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    HomePageComponent,
    WelcomePageComponent,

    NewRequestComponent,
    NewReqFormComponent,
    CoordinateSearchPageComponent,
    MapPageComponent,
    MapComponent,
    ManualRequestComponent,
    RequestOverviewComponent,
    StatisticsPageComponent,
    StatisticGridComponent,
    // 
    GipAdmDocEnvComponent,
    GipAdmDocPubComponent,
    GipAdmPropsComponent,
    GipAdmTextComponent,
    GipCompanyFormComponent,
    GipCompanyListComponent,
    GipUserLogonComponent,
    GipLogonMaintComponent,
    GipUserFormComponent,
    GipUserRegisterFormComponent,
    GipUserProcessStatFormComponent,
    GipUserResetPwdComponent,
    GipUserForgotPwdComponent,
    GipContractListComponent,
    GipContractFormComponent,
    GipContractFormatFormComponent,
    GipContractScaleFormComponent,
    GipContractPrinterFormComponent,
    GipReqDnloadFormComponent,
    GipReqReplotFormComponent,
    GipReqResetFormComponent,
    GipUserListComponent,
    GipContractFormatListComponent,
    GipContractScaleListComponent,
    GipContractPrinterListComponent,
    GipAdmDocenvListComponent,
    GipAdmDocpubListComponent,
    GipAdmPropsListComponent,
    GipAdmTextListComponent,
    GipReqStatListComponent,
    GipReqStatCListComponent,
    GipReqStatCaListComponent,
    GipReqStatSListComponent,
    GipReqStatCsListComponent,
    GipReqStatAListComponent,
    GipReqManListComponent,
    GipReqLogComponent,
    personIdDialog,
    statisticModalWindow,
    GipReqManFormComponent,
    GipReqManComponent,
    GipReqManFwdFormComponent,
    GipUserChangePwdFormComponent,
    personFwdDialog,
    personMailDialog,
    contractIdDialog,
    companyIdDialog,
    GipAdmUserPwdResetComponent,
    ConfirmationWindow,
    NoteEditDialogComponent,
    GipActivateAccountComponent,
    UploadDialogComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    SharedModule,
    UserModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      maxOpened: 5, 
      newestOnTop: true
    }),
    
  ],
  providers: [
    DatePipe,
    ToPicklistPipe,
    FromPicklistPipe,
    TranslateResourceDefinitionPipe,
    TranslateTextPipe,
    PointReplacerPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
